import {useTranslation} from "ni18n";
import React from "react";

import {Btn} from "../V5Comp";
import styles from "./Completed.module.scss";

const Completed = () => {
  const i18n = useTranslation();

  const data = [
    i18n.t("Film"),
    i18n.t("Sports"),
    i18n.t("Manufacturing"),
    i18n.t("Schools"),
    i18n.t("Healthcare"),
    i18n.t("Transportation"),
    i18n.t("Retail"),
    i18n.t("Logistics"),
  ];

  return (
    <div className={styles.wrap}>
      <div className={styles.inner}>
        <h2 className={styles.head}>
          {i18n.t("Over 2 million COVID-19 tests and 1.5 million vaccines administered")}
        </h2>
        <ul className={styles.icon}>
          {data.map(d => (
            <div key={d} className={styles.iconInner}>
              <span className={`cIcon-${d.toLocaleLowerCase()} ${styles.iconIcon}`} />
              <span className={`${styles.iconTitle}`}>{d}</span>
            </div>
          ))}
        </ul>

        <Btn className={`${styles.start} bg-white gray800`} href="#signup">
          {i18n.t("Talk to Our Team")}
        </Btn>
      </div>
    </div>
  );
};

export default React.memo(Completed);
